import React from 'react'
import { InlineCode } from './s'

import * as twentyfoursevenoffice from './24sevenoffice'
import * as azure from './azure'
import * as altinn from './altinn'
import * as cronalon from './crona-lon'
import * as fortnox from './fortnox'
import * as netvisor from './netvisor'
import * as nuu from './nuu'
import * as poweroffice from './poweroffice'
import * as slack from './slack'
import * as teamtailor from './teamtailor'
import * as tripletex from './tripletex'
import * as unimicro from './unimicro'
import * as vismadotnet from './visma.net'
import * as webhook from './webhook'
import * as xledger from './xledger'
import * as unknown from './unknown'

export const accentuate = chunks => <em><strong>{chunks}</strong></em>
export const codify = chunks => <InlineCode>{chunks}</InlineCode>

export default {
    '24sevenoffice': twentyfoursevenoffice,
    azure,
    altinn,
    cronalon,
    fortnox,
    netvisor,
    nuu,
    poweroffice,
    slack,
    teamtailor,
    tripletex,
    unimicro,
    'visma.net': vismadotnet,
    webhook,
    xledger,
    unknown
}